import React from "react";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  setOpenModalEscolherOpcao: (val: boolean) => void;
  setSelectedOption: (val: string) => void;
  setLeadCode: (val: string) => void;
  leadCode: string;
  selectedOption: string;
  dataResumo: any;
  dataVincularCodigo: any;
  refetchVincularCodigo: () => void;
  isLoadingVincularCodigo: boolean;
  selectedItem: any;
  isErrorVincularCodigo: boolean;
  setLeadProducts?: (val: {
    label: string;
    value: string;
    idLeadCorretor: string;
  }) => void;
}

const VincularCodigoModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        setOpenModalEscolherOpcao={props?.setOpenModalEscolherOpcao}
        setSelectedOption={props?.setSelectedOption}
        setLeadCode={props?.setLeadCode}
        leadCode={props?.leadCode}
        selectedOption={props?.selectedOption}
        dataResumo={props?.dataResumo}
        dataVincularCodigo={props?.dataVincularCodigo}
        refetchVincularCodigo={props?.refetchVincularCodigo}
        isLoadingVincularCodigo={props?.isLoadingVincularCodigo}
        selectedItem={props?.selectedItem}
        isErrorVincularCodigo={props?.isErrorVincularCodigo}
        setLeadProducts={props?.setLeadProducts}
      />
    </Styles.Container>
  );
};

export default VincularCodigoModal;
